// CustomTooltipWithoutRoundBorder.js
import React from 'react';
import { Tooltip } from '@mui/material';

const CustomTooltipWithoutRoundBorder = ({ title, children, placement = 'top' }) => {
    return (
        <Tooltip title={title} placement={placement} arrow>
            {children}
        </Tooltip>
    );
};

export default CustomTooltipWithoutRoundBorder;
